export function isBoardEnabled(roles?: string[]): boolean | undefined {
  return roles?.some((r) => r.includes("portal:board:"));
}

export function isPeopleEnabled(roles?: string[]): boolean | undefined {
  return roles?.some((r) => r.includes("portal:people:"));
}

export function isLibertyAIEnabled(roles?: string[]): boolean | undefined {
  return roles?.some((r) => r.includes("portal:liberty-ai:"));
}
